/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-01-14 18:39:25
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-03-13 11:01:56
 * @FilePath: \vue-hepha-order\src\views\dealerPreOrder\queryConfig\B2BShopOrderListQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const B2BShopOrderListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'customer.customerType', // 订单名称
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'order.orderName',
        },
        {
            // name:'customer.customerEmail', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'order.orderSource',
            options:[],
        },
        {
            // name:'customer.customerCountry', // 订单状态
            key:'dealer_order_status',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'order.orderStatus',
            optionToLocale:true,
            options:[
                {
                    label:'order.obligation',
                    value:7
                }
            ]
        },
        {
            // name:'customer.customerCountry', // 信用额度验证
            key:'check_status',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'B2BShopOrder.verifyStatus',
            optionToLocale:true,
            options:[
                {
                    label:'B2BShopOrder.unconfirm',
                    value:0
                },
                {
                    label:'B2BShopOrder.confirmed',
                    value:1
                },
                {
                    label:'B2BShopOrder.partiallyConfirmed',
                    value:3
                },
                {
                    label:'order.canceled',
                    value:2
                },
            ]
        },
        {
            // name:'order.deliverStatus', // 发货状态
            key:'courier_status',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.deliverStatus',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.unship',
                    disabled:false
                },
                {
                    value:1,
                    label:'order.plan',
                    disabled:false
                },
                {
                    value:2,
                    label:'order.partialShip',
                    disabled:false
                },
                {
                    value:3,
                    label:'order.shiped',
                    disabled:false
                },
                {
                    value:4,
                    label:'order.signedFor',
                    disabled:false
                },
                {
                    value:5,
                    label:'order.canceled',
                    disabled:false
                },
                {
                    value:7,
                    label:'order.partialReturn',
                    disabled:false
                },
                {
                    value:8,
                    label:'order.return',
                    disabled:false
                },
                {
                    value:10,
                    label:'order.partialExchange',
                    disabled:false
                },
                {
                    value:9,
                    label:'order.exchange',
                    disabled:false
                },
                {
                    value:99,
                    label:'order.noNeedToShip',
                    disabled:false
                },
            ]
        },
        {
            // name:'customer.customerCity', // 订单日期
            key:'order_date',
            type:'dateRange',   
            allowClear:true,
            showTime:false,
            width:'250px',
            placeholder:'order.order_timestamp',
        },
        {
            // name:'customer.customerCity', // 国家
            key:'country',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'order.country',
            options:[]
        },
    ]
}

B2BShopOrderListQuery.formField.forEach(item=>{
    B2BShopOrderListQuery.formData[item.key] = ''
})

export {
    B2BShopOrderListQuery
}